import services from './../../services/service'; // Service Class
let service = new services();

export default {
  name: "MainHeader",
  data() {
      return {
        user: {},
        user_slug: {},
        sellpoint:{},
        products: {},
        product: {},
        items:[],
        checked_out_items: [],
        img_url: service.imageURL,
        loggedIn:false,
        edit_mode:false,
      }
  },
  computed: {
    total() {
      var total = 0;
      for(var i = 0; i < this.items.length; i++) {
        total += this.items[i].product_price;
      }
      return total;
    }
},
methods: {
    
    mobileSideNavToggle(action){
        if(action == "open"){
            document.getElementById("mobileSideNav").style.width = "300px";
        }
        if(action == "close"){
            document.getElementById("mobileSideNav").style.width = "0";
        }
    },
    
    setSellpoint(){ 
        this.loading = true;
        service.getAppBusinessByUserName(this, this.$route.params.id).then(response => {
            if(response.body.status == 200) {
                this.sellpoint = response.body.data; 
                this.is_editing();
                this.loading = false;
            }else{
                
            }
        }).catch((err) => {
            this.loading = false;
           
        })
        
    },

    checkLoggedIn(){
        if(localStorage.getItem("sp_token") != null){
            this.loggedIn = true;
            this.user = localStorage.getItem("sp_user");
        }
    },

    preset() {
        var credentials = {
            session_key: localStorage.getItem("sp_token")
        } 
        if(credentials.session_key != null) {
            service.sessionGuard(this, credentials).then(response => {
                if(response.body.status == 200) {
                    let data = response.body.data;
                    data.forEach(function(element) {
                        this.user.user_id = element.user_id;
                        this.user.user_name = localStorage.getItem("sp_user");
                        this.loggedIn = true;//loggedIn options
                    }, this);
                    this.setSellpoint();
                }else {
                  //  console.log(response)
                 //// this.$router.push('/login/');
                  }
            }).catch((err) => {
                if(err) {
                    // console.log(err)
                    //this.$router.push('/login/');
                }
            })
        }else {
           //console.log("error 2")
          // this.$router.push('/login/');
        }
    },

    is_editing(){ //preseting if seller
        if(this.user.user_id != ""){
            var payload = {
                validate_user: this.user.user_id,
                validate_business: this.sellpoint.business_id
            }
            service.can_edit(this, payload).then(response => {
                if(response.body.status == 200) {
                    this.edit_mode =  true;
                    // this.can_edit = true;
                }else {
                    this.edit_mode =  false;
                }
            }).catch((err) => {
                if(err) {
                    //log error
                }
            })
        }
    },

    
  },
  created: function() {
    this.preset();
    // this.setSellpoint();
  }
}


// WEBPACK FOOTER //
// ./src/pages/MainHeader2/script.js